import React, { useState, useEffect, useCallback } from "react";
import Input from "../../input/input_v2";
import Select from "../../select/select_v2";
import Button from "../../button/button_v2";
import { Container } from "react-grid-system";
import { FormContainer } from "./styles";
import viacep from "../../../services/viacep";
import { store } from "react-notifications-component";
import api from "../../../services/api";
import { Multiselect } from 'multiselect-react-dropdown';
import validadorCpfCnpj from "../../../services/validadorCpfCnpj";
import buscaCep from "../../../services/buscaCep";
import identifyErrorMenssage from "../../../services/identifyErrorMenssage";
import { Form } from "../../../styles/global";
import MapaArea from "../../mapaArea";


const AddLocalAplicacao = ({ ...props }) => {
    const {
        produtor,
        isModal,
        updateModal
    } = props;

    const [nomeLocal, setNomeLocal] = useState('');
    const [cpfCnpjLocal, setCpfCnpjLocal] = useState('');
    const [inscricaoEstadual, setInscricaoEstadual] = useState('');
    const [cepLocal, setCepLocal] = useState('');
    const [logradouroLocal, setLogradouroLocal] = useState('');
    const [bairroLocal, setBairroLocal] = useState('');
    const [numeroLocal, setNumeroLocal] = useState('');
    const [complementoLocal, setComplementoLocal] = useState('');
    const [cidadeLocal, setCidadeLocal] = useState('');
    const [codIbge, setCodIbge] = useState('');
    const [numeroOrgao, setNumeroOrgao] = useState('');
    const [areaTotal, setAreaTotal] = useState('');
    const [culturas, setCulturas] = useState([]);
    const [mascaraCoordenada, setMascaraCoordenada] = useState(`99°99'99"S`);
    const [cadastroAmbiental, setCadastroAmbiental] = useState('');
    const [enderecoLocal, setEnderecoLocal] = useState('');
    const estados = [
        { value: "SP", label: "São Paulo" },
        { value: "RJ", label: "Rio de Janeiro" },
        { value: "SC", label: "Santa Catarina" },
        { value: "AC", label: "Acre" },
        { value: "AL", label: "Alagoas" },
        { value: "AP", label: "Amapa" },
        { value: "AM", label: "Amazonas" },
        { value: "BA", label: "Bahia" },
        { value: "CE", label: "Ceará" },
        { value: "DF", label: "Distrito Federal" },
        { value: "ES", label: "Espirito Santo" },
        { value: "GO", label: "Goiás" },
        { value: "MA", label: "Maranhão" },
        { value: "MT", label: "Mato Grosso" },
        { value: "MS", label: "Mato Grosso do Sul" },
        { value: "MG", label: "Minas Gerais" },
        { value: "PA", label: "Pará" },
        { value: "PB", label: "Paraíba" },
        { value: "PR", label: "Paraná" },
        { value: "PE", label: "Pernambuco" },
        { value: "PI", label: "Piaui" },
        { value: "RN", label: "Rio Grande do Norte" },
        { value: "RS", label: "Rio Grande do Sul" },
        { value: "RO", label: "Rondônia" },
        { value: "RR", label: "Roraima" },
        { value: "SE", label: "Sergipe" },
        { value: "TO", label: "Tocantins" },
        { value: "", label: "" }
    ];
    const [estadoLocal, setEstadoLocal] = useState('');
    const [estadoCep, setEstadoCep] = useState('');
    const [latitude, setLatitude] = useState('');
    const [longitude, setLongitude] = useState('');
    const [disabled, setDisabled] = useState(true);
    const [disabledEstado, setDisabledEstado] = useState(false);
    const [disabledCidade, setDisabledCidade] = useState(false);
    const [selected, setSelected] = useState([]);
    const [altitude, setAltitude] = useState('');

    const [erroLatitude, setErroLatitude] = useState(false);
    const [erroLongitude, setErroLongitude] = useState(false);
    const [erroAltitude, setErroAltitude] = useState(false);

    // Estados de erro específicos para formato de coordenadas
    const [erroLatitudeGraus, setErroLatitudeGraus] = useState(false);
    const [erroLatitudeMinutos, setErroLatitudeMinutos] = useState(false);
    const [erroLatitudeSegundos, setErroLatitudeSegundos] = useState(false);
    const [erroLongitudeGraus, setErroLongitudeGraus] = useState(false);
    const [erroLongitudeMinutos, setErroLongitudeMinutos] = useState(false);
    const [erroLongitudeSegundos, setErroLongitudeSegundos] = useState(false);

    const [loading, setLoading] = useState(false);
    const [loadingCep, setLoadingCep] = useState(false);
    const [loadingIbge, setLoadingIbge] = useState(false);
    const [enderecoManual, setEnderecoManual] = useState(false);
    const [cepNaoEncontrado, setCepNaoEncontrado] = useState(false);

    const [erroNome, setErroNome] = useState(false);
    const [erroNomeMsg, setErroNomeMsg] = useState('');

    const [erroCpfCnpj, setErroCpfCnpj] = useState(false);
    const [erroCpfCnpjMsg, setErroCpfCnpjMsg] = useState('');

    const [erroCep, setErroCep] = useState(false);
    const [erroCepMsg, setErroCepMsg] = useState('');

    const [erroEndereco, setErroEndereco] = useState(false);
    const [erroEnderecoMsg, setErroEnderecoMsg] = useState('');

    const [erroNumero, setErroNumero] = useState(false);
    const [erroNumeroMsg, setErroNumeroMsg] = useState('');

    const [erroBairro, setErroBairro] = useState(false);
    const [erroBairroMsg, setErroBairroMsg] = useState('');

    const [erroCidade, setErroCidade] = useState(false);
    const [erroCidadeMsg, setErroCidadeMsg] = useState('');

    const [erroEstado, setErroEstado] = useState(false);
    const [erroEstadoMsg, setErroEstadoMsg] = useState('');

    const [erroIbge, setErroIbge] = useState(false);
    const [erroIbgeMsg, setErroIbgeMsg] = useState('');

    const [isCpfValido, setIsCpfValido] = useState(false);

    const [showMapa, setShowMapa] = useState(false);

    const [modoCoord, setModoCoord] = useState(0);
    const [showInputs, setShowInputs] = useState(false);
    const [longitudeGraus, setLongitudeGraus] = useState('');
    const [longitudeMinutos, setLongitudeMinutos] = useState('');
    const [longitudeSegundos, setLongitudeSegundos] = useState('');
    const [latitudeGraus, setLatitudeGraus] = useState('');
    const [latitudeMinutos, setLatitudeMinutos] = useState('');
    const [latitudeSegundos, setLatitudeSegundos] = useState('');
    const [idOportunidade, setIdOportunidade] = useState('');
    const [enderecoCompleto, setEnderecoCompleto] = useState('');
    const [estadosObrigatorios, setEstadosObrigatorios] = useState([]);

    const isEstadoObrigatorio = useCallback(
        (estado) => estadosObrigatorios.includes(estado),
        [estadosObrigatorios],
    );


    const formatCulturas = culturas => {
        culturas = culturas.map(cultura => {
            const format = {
                name: cultura.nome_comum,
                id: cultura.id
            };
            return format;
        });
        return culturas;
    }

    useEffect(() => {
        if (props.isModal != true) {
            window.scrollTo(0, 0);
        }

        api.get(`/culturas`).then(response => {
            let culturas = response.data.data;
            culturas = formatCulturas(culturas);
            setCulturas(culturas);
        });

        const getEstadosCood = async () => {
            try {
                const response = await api.get(`/fazendas/estados`);

                let estados = [];
                if (response && response.data) {
                    if (Array.isArray(response.data.estados)) {
                        estados = response.data.estados;
                    } else if (response.data.data && Array.isArray(response.data.data.estados)) {
                        estados = response.data.data.estados;
                    }
                }

                setEstadosObrigatorios(estados);
            } catch (error) {
                store.addNotification({
                    title: "Erro!",
                    message: identifyErrorMenssage(error, "ERRO-592 Erro ao buscar estados com coordenadas obrigatorias - Tente novamente, se o erro persistir acione o suporte."),
                    type: "danger",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 4000,
                        onScreen: true
                    }
                });
            }
        };

        getEstadosCood();
    }, [])

    useEffect(() => {
        if (props.crm === true) {
            setNomeLocal(props.fazendaNomeCrm);
            setIdOportunidade(props.opId)
        }
    }, [props])

    const loadGoogleMapsAPI = () => {
        return new Promise((resolve, reject) => {
            // Verifica se a API já está carregada
            if (window.google && window.google.maps && window.google.maps.Geocoder) {
                resolve();
                return;
            }

            // Remove scripts existentes para evitar conflitos
            const existingScript = document.querySelector('script[src*="maps.googleapis.com"]');
            if (existingScript) {
                existingScript.remove();
            }

            // Define callback global para inicialização
            window.initGoogleMaps = () => {
                if (window.google && window.google.maps && window.google.maps.Geocoder) {
                    // Limpa o callback global após o uso
                    delete window.initGoogleMaps;
                    resolve();
                } else {
                    delete window.initGoogleMaps;
                    reject(new Error('Google Maps API não inicializou corretamente'));
                }
            };

            // Cria e adiciona o script da API com loading=async
            const script = document.createElement('script');
            script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyAn3UaVotrho9E6f_BWtW4wDshxnEmM8LI&libraries=places,drawing&loading=async&callback=initGoogleMaps';
            script.async = true;
            script.defer = true;

            script.onerror = () => {
                reject(new Error('Erro ao carregar Google Maps API'));
            };

            // Timeout de segurança
            setTimeout(() => {
                if (window.initGoogleMaps) {
                    delete window.initGoogleMaps;
                }
                reject(new Error('Timeout ao carregar Google Maps API'));
            }, 15000);

            document.head.appendChild(script);
        });
    };

    const geocodeWithGoogleMaps = async (endereco) => {
        try {
            await loadGoogleMapsAPI();

            return new Promise((resolve, reject) => {
                const geocoder = new window.google.maps.Geocoder();
                geocoder.geocode({ address: endereco }, (results, status) => {
                    if (status === 'OK' && results[0]) {

                        const location = results[0].geometry.location;

                        const lat = location.lat();
                        const lng = location.lng();

                        setLatitude(lat);
                        setLongitude(lng);

                        resolve({ lat, lng });
                    } else {
                        reject(new Error(`Geocoding falhou: ${status}`));
                    }
                });
            });
        } catch (error) {
            console.error('Erro ao carregar/usar Google Maps:', error);
            throw error;
        }
    };

    const geocodeWithAlternativeAPI = async (endereco) => {
        try {
            const response = await fetch(`https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(endereco)}&limit=1`);
            const data = await response.json();

            if (data && data.length > 0) {
                const lat = parseFloat(data[0].lat);
                const lng = parseFloat(data[0].lon);

                setLatitude(lat);
                setLongitude(lng);

                return { lat, lng };
            } else {
                return false;
            }
        } catch (error) {
            console.error('Erro na geocodificação alternativa:', error);
            return false;
        }
    };

    const fetchCep = async () => {
        try {
            setLoadingCep(true);
            setCepNaoEncontrado(false);
            setEnderecoManual(false);

            const cep = await buscaCep(cepLocal);

            const { logradouro, ibge, bairro, localidade, uf } = cep;

            setLogradouroLocal(logradouro);
            setBairroLocal(bairro);
            setCidadeLocal(localidade);
            setCodIbge(ibge);
            setEstadoLocal(uf);
            setEstadoCep(uf);

            setLoadingCep(false);

            setErroCep(false);
            setErroEndereco(false);
            setErroBairro(false);
            setErroCidade(false);
            setErroEstado(false);

        } catch (err) {
            setLoadingCep(false);
            setErroCep(err.type === "invalid");
            setErroCepMsg(err.type === "invalid" ? err.message : "");

            if (err.type === "not_found" || err.type === "provider_error") {
                setEnderecoManual(true);
                setLogradouroLocal("");
                setBairroLocal("");
                setCidadeLocal("");
                setCodIbge("");

                store.addNotification({
                    title: "Atenção!",
                    message: identifyErrorMenssage(err, "ERRO-593 CEP não encontrado. Preencha o endereço manualmente ou tente novamente - Tente novamente, se o erro persistir acione o suporte."),
                    type: "warning",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 5000,
                        onScreen: true
                    }
                });
            }
        }
    };


    const validateCoordinatesFormat = () => {
        const isRequired = isEstadoObrigatorio(estadoLocal);
        
        // Reset dos erros específicos
        setErroLatitudeGraus(false);
        setErroLatitudeMinutos(false);
        setErroLatitudeSegundos(false);
        setErroLongitudeGraus(false);
        setErroLongitudeMinutos(false);
        setErroLongitudeSegundos(false);

        // Se coordenadas foram selecionadas pelo mapa (latitude e longitude existem mas campos manuais estão vazios)
        if (latitude && longitude && !latitudeGraus && !latitudeMinutos && !latitudeSegundos && !longitudeGraus && !longitudeMinutos && !longitudeSegundos) {
            return { isValid: true }; // Coordenadas do mapa são sempre válidas
        }

        // Se coordenadas são obrigatórias
        if (isRequired) {
            const nenhumCampoManualPreenchido =
                !latitudeGraus && !latitudeMinutos && !latitudeSegundos &&
                !longitudeGraus && !longitudeMinutos && !longitudeSegundos;
            const semCoordenadaMapa = !latitude && !longitude;

            // Se o usuário não informou nenhuma coordenada (nem pelo mapa, nem manualmente)
            if (semCoordenadaMapa && nenhumCampoManualPreenchido) {
                setErroLatitude(true);
                setErroLongitude(true);
                return { isValid: false, message: "É obrigatório informar as coordenadas geográficas." };
            }

            // Validação de latitude
            if (!latitudeGraus || latitudeGraus.length !== 2) {
                setErroLatitudeGraus(true);
                return { isValid: false, message: "Latitude: Graus deve ter exatamente 2 dígitos" };
            }
            if (!latitudeMinutos || latitudeMinutos.length !== 2) {
                setErroLatitudeMinutos(true);
                return { isValid: false, message: "Latitude: Minutos deve ter exatamente 2 dígitos" };
            }
            if (!latitudeSegundos || latitudeSegundos.length !== 4) {
                setErroLatitudeSegundos(true);
                return { isValid: false, message: "Latitude: Segundos deve ter exatamente 4 dígitos" };
            }

            // Validação de longitude
            if (!longitudeGraus || longitudeGraus.length !== 2) {
                setErroLongitudeGraus(true);
                return { isValid: false, message: "Longitude: Graus deve ter exatamente 2 dígitos" };
            }
            if (!longitudeMinutos || longitudeMinutos.length !== 2) {
                setErroLongitudeMinutos(true);
                return { isValid: false, message: "Longitude: Minutos deve ter exatamente 2 dígitos" };
            }
            if (!longitudeSegundos || longitudeSegundos.length !== 4) {
                setErroLongitudeSegundos(true);
                return { isValid: false, message: "Longitude: Segundos deve ter exatamente 4 dígitos" };
            }
        } else {
            // Se coordenadas são opcionais, mas foram preenchidas, validar formato
            if (latitudeGraus || latitudeMinutos || latitudeSegundos) {
                if (latitudeGraus && latitudeGraus.length !== 2) {
                    setErroLatitudeGraus(true);
                    return { isValid: false, message: "Latitude: Graus deve ter exatamente 2 dígitos" };
                }
                if (latitudeMinutos && latitudeMinutos.length !== 2) {
                    setErroLatitudeMinutos(true);
                    return { isValid: false, message: "Latitude: Minutos deve ter exatamente 2 dígitos" };
                }
                if (latitudeSegundos && latitudeSegundos.length !== 4) {
                    setErroLatitudeSegundos(true);
                    return { isValid: false, message: "Latitude: Segundos deve ter exatamente 4 dígitos" };
                }
            }

            if (longitudeGraus || longitudeMinutos || longitudeSegundos) {
                if (longitudeGraus && longitudeGraus.length !== 2) {
                    setErroLongitudeGraus(true);
                    return { isValid: false, message: "Longitude: Graus deve ter exatamente 2 dígitos" };
                }
                if (longitudeMinutos && longitudeMinutos.length !== 2) {
                    setErroLongitudeMinutos(true);
                    return { isValid: false, message: "Longitude: Minutos deve ter exatamente 2 dígitos" };
                }
                if (longitudeSegundos && longitudeSegundos.length !== 4) {
                    setErroLongitudeSegundos(true);
                    return { isValid: false, message: "Longitude: Segundos deve ter exatamente 4 dígitos" };
                }
            }
        }

        return { isValid: true };
    };

    const handlePost = async () => {
        setLoading(true);

        // Validação de formato de coordenadas
        const coordValidation = validateCoordinatesFormat();
        if (!coordValidation.isValid) {
            store.addNotification({
                title: "Erro",
                message: coordValidation.message,
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                    duration: 5000,
                    onScreen: true
                }
            });
            setLoading(false);
            return;
        }

        if (erroCpfCnpj === true) {
            store.addNotification({
                title: "Erro!",
                message: "Informe um CPF válido!",
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });
            setLoading(false);

        } else {
            if (estadoLocal === 'SC') {
                if (altitude === '' || !altitude) {
                    setErroAltitude(true);
                    setLoading(false);

                    return false;
                }
            }

            let lat = latitude;
            let lng = longitude;
            let existErro = false;

            if (lat === '' && lng === '') {
                lat = `${latitudeGraus}°${latitudeMinutos}'${latitudeSegundos}"S`;
                lng = `${longitudeGraus}°${longitudeMinutos}'${longitudeSegundos}"W`

            }

            if (isEstadoObrigatorio(estadoLocal)) {
                if (lat === '' || lat === `°'"S`) {
                    setErroLatitude(true);
                    existErro = true;
                }
                if (lng === '' || lng === `°'"W`) {
                    setErroLongitude(true);
                    existErro = true;

                }

                if (estadoLocal === 'SC' && altitude === '') {
                    setErroAltitude(true);
                    existErro = true;

                }
            }

            if (latitude === '' && longitude === '') {
                try {
                    const result = await geocodeWithGoogleMaps(enderecoCompleto);
                    if (result) {
                        lat = result.lat;
                        lng = result.lng;
                    }
                } catch (error) {
                    const result = await geocodeWithAlternativeAPI(enderecoCompleto);
                    if (result) {
                        lat = result.lat;
                        lng = result.lng;
                    }
                }
            }

            if (existErro == false) {
                const payloadB = {
                    nome: nomeLocal,
                    cpf_cnpj: isCpfValido ? cpfCnpjLocal : '',
                    cod_ibge: codIbge,
                    cultura: selected,
                    area_total: areaTotal,
                    inscricao_estadual: inscricaoEstadual,
                    cadastro_ambiental: cadastroAmbiental,
                    inscricao_orgao: numeroOrgao,
                    cep: cepLocal,
                    endereco: enderecoLocal,
                    numero: numeroLocal,
                    complemento: complementoLocal,
                    bairro: bairroLocal,
                    estado: estadoLocal,
                    cidade: cidadeLocal,
                    latitude: latitude !== '' ? String(latitude) : String(lat),
                    longitude: longitude !== '' ? String(longitude) : String(lng),
                    altitude,
                    endereco_manual: enderecoManual,
                };

                const local = produtor;

                try {
                    const response = await api.post(`/produtores/${local}/fazendas`, payloadB);

                    const id_fazenda = response.data.data.id;
                    const id_produtor = response.data.data.agro_producer_id;
                    const payload_culturas = {
                        agro_farms_id: id_fazenda,
                        agro_producers_id: id_produtor,
                        cultura: selected.length > 0 ? selected : [],
                        status: 1
                    }

                    if (props.crm === true) {
                        ConvertClient(id_fazenda, id_produtor)
                    }

                    await api.post(`/fazenda/culturas`, payload_culturas);
                    setLoading(false);

                    store.addNotification({
                        title: "Sucesso!",
                        message: "O local de aplicação foi salvo!",
                        type: "success",
                        insert: "top",
                        container: "top-right",
                        animationIn: ["animated", "fadeIn"],
                        animationOut: ["animated", "fadeOut"],
                        dismiss: {
                            duration: 4000,
                            onScreen: true
                        }
                    });

                    if (props.crm !== true) {
                        if (isModal === true) {
                            updateModal();
                        } else {

                            if (props.returnTo) {
                                props.loc.history.push(props.returnTo);

                            } else {
                                props.loc.history.push('/produtores');
                            }
                        }
                    }



                } catch (err) {
                    setLoading(false);

                    setErroNome(false);
                    setErroCpfCnpj(false);
                    setErroNumero(false);
                    setErroCep(false);
                    setErroEndereco(false);
                    setErroBairro(false);
                    setErroCidade(false);
                    setErroEstado(false);
                    setErroIbge(false);
                    setErroLatitude(false);
                    setErroLongitude(false);


                    if (err.response?.data?.message && Array.isArray(err.response.data.message)) {
                        const errorMessages = err.response.data.message;

                        errorMessages.forEach(message => {
                            if (message.includes('nome should not be empty')) {
                                setErroNome(true);
                                setErroNomeMsg('O campo nome não pode estar vazio');
                            } else if (message.includes('cpf_cnpj should not be empty')) {
                                setErroCpfCnpj(true);
                                setErroCpfCnpjMsg('O campo cpf/cnpj não pode estar vazio');
                            } else if (message.includes('cep should not be empty')) {
                                setErroCep(true);
                                setErroCepMsg('O campo cep não pode estar vazio');
                            } else if (message.includes('endereco should not be empty')) {
                                setErroEndereco(true);
                                setErroEnderecoMsg('O campo endereco não pode estar vazio');
                            } else if (message.includes('bairro should not be empty')) {
                                setErroBairro(true);
                                setErroBairroMsg('O campo bairro não pode estar vazio');
                            } else if (message.includes('numero should not be empty')) {
                                setErroNumero(true);
                                setErroNumeroMsg('O campo numero não pode estar vazio');
                            } else if (message.includes('cidade should not be empty')) {
                                setErroCidade(true);
                                setErroCidadeMsg('O campo cidade não pode estar vazio');
                            } else if (message.includes('estado should not be empty')) {
                                setErroEstado(true);
                                setErroEstadoMsg('O campo estado não pode estar vazio');
                            } else if (message.includes('cod_ibge should not be empty')) {
                                setErroIbge(true);
                                setErroIbgeMsg('O campo IBGE não pode estar vazio');
                            }
                        });

                    }

                    const ERRO = err.response.data.errors;
                    try {

                        const errors = err.response.data.errors;

                        for (let field in errors) {
                            if (field === 'nome') {
                                setErroNome(true);
                                setErroNomeMsg('O campo não pode estar em branco');
                            } else if (field === 'cpf_cnpj') {
                                setErroCpfCnpj(true);
                                setErroCpfCnpjMsg('O campo não pode estar em branco');
                            } else if (field === 'cep') {
                                setErroCep(true);
                                setErroCepMsg('O campo não pode estar em branco');
                            } else if (field === 'endereco') {
                                setErroEndereco(true);
                                setErroEnderecoMsg('O campo não pode estar em branco');
                            } else if (field === 'numero') {
                                setErroNumero(true);
                                setErroNumeroMsg('O campo não pode estar em branco');
                            } else if (field === 'bairro') {
                                setErroBairro(true);
                                setErroBairroMsg('O campo não pode estar em branco');
                            } else if (field === 'cidade') {
                                setErroCidade(true);
                                setErroCidadeMsg('O campo não pode estar em branco');
                            } else if (field === 'estado') {
                                setErroEstado(true);
                                setErroEstadoMsg('O campo não pode estar em branco');
                            } else if (field === 'latitude') {
                                setErroLatitude(true);
                            } else if (field === 'longitude') {
                                setErroLongitude(true)
                            }
                        }

                        store.addNotification({
                            title: "Erro!",
                            message: "Verifique os campos em vermelho",
                            type: "danger",
                            insert: "top",
                            container: "top-right",
                            animationIn: ["animated", "fadeIn"],
                            animationOut: ["animated", "fadeOut"],
                            dismiss: {
                                duration: 4000,
                                onScreen: true
                            }
                        });
                    } catch (err) {
                        store.addNotification({
                            title: "Erro!",
                            message: identifyErrorMenssage(err, String(ERRO || "Erro ao salvar o local de aplicacao.")),
                            type: "danger",
                            insert: "top",
                            container: "top-right",
                            animationIn: ["animated", "fadeIn"],
                            animationOut: ["animated", "fadeOut"],
                            dismiss: {
                                duration: 4000,
                                onScreen: true
                            }
                        });
                    }
                }
            } else {
                setLoading(false);
                store.addNotification({
                    title: "Erro!",
                    message: "Verifique os campos em vermelho",
                    type: "danger",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 4000,
                        onScreen: true
                    }
                });
            }

        }

    }

    const ConvertClient = async (id_fazenda, id_produtor) => {
        try {

            const payload = {
                id_fazenda: id_fazenda,
                id_produtor: id_produtor
            }
            const response = await api.post(`/oportunidade/converter/${idOportunidade}`, payload)

            if (response) {
                props.closeModal()
                props.getOp()

            }

        } catch (error) {


        }


    }

    const disabledverify = () => {
        if (isEstadoObrigatorio(estadoLocal)) {
            if (estadoLocal && nomeLocal && cpfCnpjLocal && inscricaoEstadual && cepLocal && logradouroLocal && numeroLocal && bairroLocal && cidadeLocal && codIbge && latitude && longitude) {
                setDisabled(false);
            } else {
                setDisabled(true);
            }
        } else {
            if (estadoLocal && nomeLocal && cpfCnpjLocal && inscricaoEstadual && cepLocal && logradouroLocal && numeroLocal && bairroLocal && cidadeLocal && codIbge) {
                setDisabled(false);
            } else {
                setDisabled(true);
            }
        }
    }

    const validateNome = nomeLocal => {
        setNomeLocal(nomeLocal);
        setErroNome(false);

    }
    const validateCpfCnpj = cpfCnpjLocal => {
        setCpfCnpjLocal(cpfCnpjLocal);
        setErroCpfCnpj(false);

    }
    const validateInscricao = inscricaoEstadual => {
        setInscricaoEstadual(inscricaoEstadual);
    }
    const validateCep = cepLocal => {
        setCepLocal(cepLocal);
        setErroCep(false);

    }
    const validateNumero = numeroLocal => {
        setNumeroLocal(numeroLocal);
        setErroNumero(false);

    }
    const validateComplemento = complementoLocal => {
        setComplementoLocal(complementoLocal);
    }
    const validateEndereco = logrLocal => {
        setLogradouroLocal(logrLocal);
        setErroEndereco(false);

    }
    const validateBairro = bairroLocal => {
        setBairroLocal(bairroLocal);
        setErroBairro(false);

    }
    const validateCidade = cidadeLocal => {
        setCidadeLocal(cidadeLocal);
        setErroCidade(false);

    }
    const validateCodIbge = codIbge => {
        setErroIbge(false);
        setCodIbge(codIbge);
    }
    const validateNumOrgao = numeroOrgao => {
        setNumeroOrgao(numeroOrgao);
    }
    const validateArea = areaTotal => {
        setAreaTotal(areaTotal);
    }
    const validateCadastro = cadastroAmbiental => {
        setCadastroAmbiental(cadastroAmbiental);
    }

    const changeCoordinates = (lat, lng) => {
        setLatitude(`${lat}`);
        setLongitude(`${lng}`);
        
        // Limpar os campos de graus, minutos e segundos quando coordenadas são selecionadas pelo mapa
        setLatitudeGraus('');
        setLatitudeMinutos('');
        setLatitudeSegundos('');
        setLongitudeGraus('');
        setLongitudeMinutos('');
        setLongitudeSegundos('');
        
        // Limpar todos os erros de coordenadas quando selecionadas pelo mapa
        setErroLatitudeGraus(false);
        setErroLatitudeMinutos(false);
        setErroLatitudeSegundos(false);
        setErroLongitudeGraus(false);
        setErroLongitudeMinutos(false);
        setErroLongitudeSegundos(false);
    }

    const validateAltitude = (valor) => {
        setAltitude(valor);
        setErroAltitude(false);
    }

    const onSelect = (selectedList, selectedItem) => {
        setSelected([])
        const b = [];
        const a = selectedList.map((list) => {
            b.push(list.id)
        })
        setSelected(b)
    }

    const onRemove = (selectedList, removedItem) => {
        setSelected([])
        const b = [];
        const a = selectedList.map((list) => {
            b.push(list.id)
        })
        setSelected(b)
    }

    const validaCpf = async (value) => {
        if (!value) {
            setIsCpfValido(false);
            setErroCpfCnpj(false);
            return;
        }

        const resultado = await validadorCpfCnpj(value);

        setIsCpfValido(resultado.valido);
        setErroCpfCnpj(!resultado.valido);
        setErroCpfCnpjMsg(resultado.erro || 'Informe um CPF/CNPJ válido');

        if (!resultado.valido) {
            store.addNotification({
                title: "Erro!",
                message: resultado.erro || "Informe um CPF/CNPJ válido.",
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });
        }
    }

    const validateEstado = uf => {
        if (estadoLocal != uf) {
            setEstadoLocal(uf);
        }
        setErroEstado(false);
    }

    const validateEnderecoParaMapa = () => {
        let completo = true;

        if (!cepLocal) {
            setErroCep(true);
            setErroCepMsg('O campo CEP não pode estar vazio');
            completo = false;
        }
        if (!logradouroLocal) {
            setErroEndereco(true);
            setErroEnderecoMsg('O campo endereço não pode estar vazio');
            completo = false;
        }
        if (!numeroLocal) {
            setErroNumero(true);
            setErroNumeroMsg('O campo número não pode estar vazio');
            completo = false;
        }
        if (!bairroLocal) {
            setErroBairro(true);
            setErroBairroMsg('O campo bairro não pode estar vazio');
            completo = false;
        }
        if (!cidadeLocal) {
            setErroCidade(true);
            setErroCidadeMsg('O campo cidade não pode estar vazio');
            completo = false;
        }
        if (!estadoLocal) {
            setErroEstado(true);
            setErroEstadoMsg('O campo estado não pode estar vazio');
            completo = false;
        }

        return completo;
    }

    const changeModoCoord = (e) => {
        if (e.value === 1) {
            const enderecoCompleto = validateEnderecoParaMapa();
            if (!enderecoCompleto) {
                store.addNotification({
                    title: "Erro!",
                    message: "Preencha todos os campos referentes ao endereço do local de aplicação para abrir o mapa com as coordenadas geográficas.",
                    type: "danger",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 5000,
                        onScreen: true
                    }
                });
            }
        }

        setModoCoord(e)
        if (e.value == 2) {
            setShowMapa(false);
            setShowInputs(true);
        } else {
            setShowMapa(true);
            setShowInputs(false);
        }
    }
    useEffect(() => {
        setEnderecoLocal(logradouroLocal);
    }, [logradouroLocal])

    useEffect(() => {
        const enderecoformat = `${logradouroLocal}, ${numeroLocal} ${complementoLocal} - ${bairroLocal} - ${cidadeLocal} - ${estadoLocal}`;
        setEnderecoCompleto(enderecoformat);
    }, [cepLocal, numeroLocal])



    useEffect(() => {
        disabledverify();
    }, [estadoLocal, nomeLocal, cpfCnpjLocal, inscricaoEstadual, cepLocal, logradouroLocal, numeroLocal, complementoLocal, bairroLocal, cidadeLocal, codIbge, numeroOrgao, areaTotal, cadastroAmbiental, latitude, longitude, disabledverify]);

    useEffect(() => {
        if (enderecoManual) {
            setDisabledCidade(false);
            setDisabledEstado(false);
        } else if (estadoLocal && cidadeLocal) {
            setDisabledCidade(true);
            setDisabledEstado(true);
        } else {
            setDisabledCidade(false);
            if (estadoLocal) {
                setDisabledEstado(true);
            } else {
                setDisabledEstado(false);
            }
        }
    }, [estadoLocal, cidadeLocal, enderecoManual])

    // Endereço manual (CEP não encontrado) não tem de onde puxar o código IBGE - busca na
    // API pública do IBGE por cidade+estado, em vez de pedir pro usuário digitar/procurar.
    const normalizarTextoIbge = (texto) =>
        String(texto || '')
            .normalize('NFD')
            .replace(/[̀-ͯ]/g, '')
            .toLowerCase()
            .trim();

    const buscarCodigoIbgePorCidade = async (cidade, uf) => {
        try {
            const response = await fetch(`https://servicodados.ibge.gov.br/api/v1/localidades/estados/${uf}/municipios`);
            if (!response.ok) return null;
            const municipios = await response.json();
            const alvo = normalizarTextoIbge(cidade);
            const encontrado = municipios.find((m) => normalizarTextoIbge(m.nome) === alvo);
            return encontrado ? String(encontrado.id) : null;
        } catch (error) {
            console.error('Erro ao buscar código IBGE automaticamente:', error);
            return null;
        }
    };

    useEffect(() => {
        if (!enderecoManual || !cidadeLocal || !estadoLocal || codIbge) return;

        let cancelado = false;
        setLoadingIbge(true);
        buscarCodigoIbgePorCidade(cidadeLocal, estadoLocal).then((codigo) => {
            if (cancelado) return;
            if (codigo) setCodIbge(codigo);
            setLoadingIbge(false);
        });

        return () => { cancelado = true; };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [enderecoManual, cidadeLocal, estadoLocal])


    useEffect(() => {
        if (isEstadoObrigatorio(estadoLocal)) {
            // setShowMapa(true);
        } else {
            setShowMapa(false);
        }
    }, [estadoLocal, isEstadoObrigatorio])






    const validateLatitude = async (tipo, valor) => {
        // Limpar erros ao começar a digitar
        setErroLatitude(false);
        setErroLatitudeGraus(false);
        setErroLatitudeMinutos(false);
        setErroLatitudeSegundos(false);

        if (tipo == 1) {

            if (latitudeGraus.length > valor.length) {
                //apagando o valor
                if (valor.length == 3) {
                    let separa = valor.split("");
                    if (separa[2] == ".") {
                        setLatitudeGraus(`${separa[0]}${separa[1]}`);
                    } else {
                        setLatitudeGraus(valor);
                    }
                } else {
                    setLatitudeGraus(valor);
                }
            } else {
                //digitando o valor
                if (valor.length == 3) {
                    let separa = valor.split("");
                    if (separa[2] == ".") {
                        setLatitudeGraus(valor);
                    } else {

                        if (separa[2] == ',') {
                            setLatitudeGraus(`${separa[0]}${separa[1]}.`);
                        } else {
                            setLatitudeGraus(`${separa[0]}${separa[1]}.${separa[2]}`);
                        }
                    }
                } else {
                    setLatitudeGraus(valor);
                }
            }

        } else if (tipo == 2) {

            if (latitudeMinutos.length > valor.length) {
                //apagando o valor

                if (valor.length == 3) {
                    let separa = valor.split("");
                    if (separa[2] == ".") {
                        setLatitudeMinutos(`${separa[0]}${separa[1]}`);
                    } else {
                        setLatitudeMinutos(valor);
                    }
                } else {
                    setLatitudeMinutos(valor);
                }
            } else {
                //digitando o valor
                if (valor.length == 3) {
                    let separa = valor.split("");
                    if (separa[2] == ".") {
                        setLatitudeMinutos(valor);
                    } else {

                        if (separa[2] == ',') {
                            setLatitudeMinutos(`${separa[0]}${separa[1]}.`);
                        } else {
                            setLatitudeMinutos(`${separa[0]}${separa[1]}.${separa[2]}`);
                        }
                    }
                } else {
                    setLatitudeMinutos(valor);
                }
            }

        } else if (tipo == 3) {

            if (latitudeSegundos.length > valor.length) {
                //apagando o valor
                if (valor.length == 3) {
                    let separa = valor.split("");
                    if (separa[2] == ".") {
                        setLatitudeSegundos(`${separa[0]}${separa[1]}`);
                    } else {
                        setLatitudeSegundos(valor);
                    }
                } else {
                    setLatitudeSegundos(valor);
                }
            } else {
                //digitando o valor
                if (valor.length == 3) {
                    let separa = valor.split("");
                    if (separa[2] == ".") {
                        setLatitudeSegundos(valor);
                    } else {

                        if (separa[2] == ',') {
                            setLatitudeSegundos(`${separa[0]}${separa[1]}.`);
                        } else {
                            setLatitudeSegundos(`${separa[0]}${separa[1]}.${separa[2]}`);
                        }
                    }
                } else {
                    setLatitudeSegundos(valor);
                }
            }
        }

        if (latitudeGraus && latitudeMinutos && latitudeSegundos) {
            if (tipo == 3) {
                setLatitude(`${latitudeGraus}°${latitudeMinutos}'${valor}"S`);
            } else {
                setLatitude(`${latitudeGraus}°${latitudeMinutos}'${latitudeSegundos}"S`);
            }
        }
    }

    const validateLongitude = (tipo, e) => {
        // Limpar erros ao começar a digitar
        setErroLongitude(false);
        setErroLongitudeGraus(false);
        setErroLongitudeMinutos(false);
        setErroLongitudeSegundos(false);

        const valor = e;
        if (tipo == 1) {

            if (longitudeGraus.length > valor.length) {
                //apagando o valor
                if (valor.length == 3) {
                    let separa = valor.split("");
                    if (separa[2] == ".") {
                        setLongitudeGraus(`${separa[0]}${separa[1]}`);
                    } else {
                        setLongitudeGraus(valor);
                    }
                } else {
                    setLongitudeGraus(valor);
                }
            } else {
                //digitando o valor

                if (valor.length == 3) {
                    let separa = valor.split("");
                    if (separa[2] == ".") {
                        setLongitudeGraus(valor);
                    } else {

                        if (separa[2] == ',') {
                            setLongitudeGraus(`${separa[0]}${separa[1]}.`);
                        } else {
                            setLongitudeGraus(`${separa[0]}${separa[1]}.${separa[2]}`);
                        }
                    }
                } else {
                    setLongitudeGraus(valor);
                }
            }

        } else if (tipo == 2) {

            if (longitudeMinutos.length > valor.length) {
                //apagando o valor
                if (valor.length == 3) {
                    let separa = valor.split("");
                    if (separa[2] == ".") {
                        setLongitudeMinutos(`${separa[0]}${separa[1]}`);
                    } else {
                        setLongitudeMinutos(valor);
                    }
                } else {
                    setLongitudeMinutos(valor);
                }
            } else {
                //digitando o valor
                if (valor.length == 3) {
                    let separa = valor.split("");
                    if (separa[2] == ".") {
                        setLongitudeMinutos(valor);
                    } else {

                        if (separa[2] == ',') {
                            setLongitudeMinutos(`${separa[0]}${separa[1]}.`);
                        } else {
                            setLongitudeMinutos(`${separa[0]}${separa[1]}.${separa[2]}`);
                        }
                    }
                } else {
                    setLongitudeMinutos(valor);
                }
            }

        } else if (tipo == 3) {

            if (longitudeSegundos.length > valor.length) {
                //apagando o valor
                if (valor.length == 3) {
                    let separa = valor.split("");
                    if (separa[2] == ".") {
                        setLongitudeSegundos(`${separa[0]}${separa[1]}`);
                    } else {
                        setLongitudeSegundos(valor);
                    }
                } else {
                    setLongitudeSegundos(valor);
                }
            } else {
                //digitando o valor
                if (valor.length == 3) {
                    let separa = valor.split("");
                    if (separa[2] == ".") {
                        setLongitudeSegundos(valor);
                    } else {

                        if (separa[2] == ',') {
                            setLongitudeSegundos(`${separa[0]}${separa[1]}.`);
                        } else {
                            setLongitudeSegundos(`${separa[0]}${separa[1]}.${separa[2]}`);
                        }
                    }
                } else {
                    setLongitudeSegundos(valor);
                }
            }
        }

        if (longitudeGraus && longitudeMinutos && longitudeSegundos) {
            if (tipo == 3) {
                setLongitude(`${longitudeGraus}°${longitudeMinutos}'${valor}"W`);
            } else {
                setLongitude(`${longitudeGraus}°${longitudeMinutos}'${longitudeSegundos}"W`);
            }
        }
    }

    useEffect(() => {
        if (modoCoord.value === 1) {
            setShowMapa(true);
        } else if (modoCoord.value === 2) {
            setShowInputs(true);
        }
    }, [modoCoord])

    return (<>
        <Form
            onSubmit={handlePost}
            step={2}
            isModal={props.isModal}
            isFocus={props.isFocus}
        >
            <Input
                marginBottom="4px"
                label="Nome da fazenda"
                name="nome"
                className="input"
                id="farm_nome"
                onChange={e => validateNome(e)}
                maxlength={50}
                erro={erroNome}
                messageErro={erroNomeMsg}
                value={nomeLocal}
                labelWithAsterisk
            />

            <Input
                marginBottom="4px"
                label="CPF/CNPJ"
                name="cpfcnpj"
                className="input"
                id="farm_cpf_cnpj"
                onChange={e => validateCpfCnpj(e)}
                value={cpfCnpjLocal}
                erro={erroCpfCnpj}
                messageErro={erroCpfCnpjMsg}
                maxlength={18}
                onBlur={(e) => validaCpf(e.target.value)}
                inputmode="numeric"
                labelWithAsterisk
            />

            <Input
                marginBottom="4px"
                label="Inscrição Estadual"
                name="inscricaoEstadual"
                className="input"
                id="farm_inscricao_estadual"
                onChange={e => validateInscricao(e)}
                value={inscricaoEstadual}
            />

            <Input
                marginBottom="4px"
                label="CEP"
                name="cep"
                className="input"
                id="farm_cep"
                onChange={e => validateCep(e)}
                onBlur={fetchCep}
                maxLength={10}
                value={cepLocal}
                loading={loadingCep}
                disabled={loadingCep}
                erro={erroCep}
                messageErro={erroCepMsg}
                inputmode="numeric"
                labelWithAsterisk
            />

            <Input
                marginBottom="4px"
                label="Logradouro"
                value={logradouroLocal}
                name="logradouroLocal"
                className="input"
                id="farm_endereco"
                onChange={e => validateEndereco(e)}
                loading={loadingCep && !enderecoManual}
                disabled={loadingCep && !enderecoManual}
                erro={erroEndereco}
                messageErro={erroEnderecoMsg}
                labelWithAsterisk
            />

            <Input
                marginBottom="4px"
                label="Bairro"
                value={bairroLocal}
                name="bairroLocal"
                className="input"
                id="farm_bairro"
                onChange={e => validateBairro(e)}
                loading={loadingCep && !enderecoManual}
                disabled={loadingCep && !enderecoManual}
                erro={erroBairro}
                messageErro={erroBairroMsg}
                labelWithAsterisk
            />

            <Input
                marginBottom="4px"
                label="Número"
                name="numeroLocal"
                className="input"
                id="farm_numero"
                onChange={e => validateNumero(e)}
                maxLength={5}
                erro={erroNumero}
                messageErro={erroNumeroMsg}
                value={numeroLocal}
                labelWithAsterisk
            />

            <Input
                marginBottom="4px"
                label="Complemento"
                name="complementoLocal"
                className="input"
                id="farm_complementoLocal"
                onChange={e => validateComplemento(e)}
                value={complementoLocal}
            />

            <Input
                marginBottom="4px"
                label="Código IBGE"
                value={codIbge}
                name="codIbge"
                className="input"
                id="farm_cod_ibge"
                onChange={e => validateCodIbge(e)}
                erro={erroIbge}
                messageErro={erroIbgeMsg}
                loading={(loadingCep && !enderecoManual) || loadingIbge}
                disabled={(loadingCep && !enderecoManual) || loadingIbge}
                inputmode="numeric"
                labelWithAsterisk
            />

            <Input
                marginBottom="4px"
                label="Cidade"
                value={cidadeLocal}
                name="cidadeLocal"
                className="input"
                id="farm_cidade"
                onChange={e => validateCidade(e)}
                loading={loadingCep && !enderecoManual}
                disabled={loadingCep && !enderecoManual}
                erro={erroCidade}
                messageErro={erroCidadeMsg}
                labelWithAsterisk
            />

            <Select
                height="auto"
                marginBottom="36px"
                label="Estado"
                name="estado"
                className="select"
                id="farm_estado_id"
                onChange={(e) => e.value ? validateEstado(e.value) : validateEstado(e)}
                options={estados}
                value={estadoLocal}
                estado={true}
                loading={loadingCep && !enderecoManual}
                disabled={disabledEstado || (loadingCep && !enderecoManual)}
                erro={erroEstado}
                messageErro={false}
                labelWithAsterisk
            />

            <Input
                marginBottom="4px"
                label="N° inscrição do produtor ao órgão estadual"
                name="numeroOrgao"
                className="input"
                id="farm_inscricao_orgao"
                onChange={e => validateNumOrgao(e)}
                value={numeroOrgao}
            />

            <Input
                marginBottom="24px"
                label="Área Total (ha)"
                name="areaTotal"
                className="input"
                id="farm_areaTotal"
                onChange={e => validateArea(e)}
                value={areaTotal}
                inputmode="numeric"
            />
            {/* -----------------------------------------------------------------------------------> */}

            <div style={{ width: '100%', marginTop: '-13px', marginBottom: '24px', display: 'flex', flexDirection: 'column' }}>
                <label id="labelcultura">Culturas</label>
                <Multiselect
                    style={{ borderRadius: '8px' }}
                    label="Culturas"
                    options={culturas}
                    placeholder="" // Options to display in the dropdown
                    closeIcon="close"
                    onSelect={onSelect}
                    onRemove={onRemove}
                    displayValue="name" // Property name to display in the dropdown options
                />
            </div>

            {/* -----------------------------------------------------------------------------------> */}

            <Input
                label="Cadastro Ambiental Rural"
                name="cadastroAmbientalRural"
                className="input"
                id="cadastro_ambiental"
                onChange={e => validateCadastro(e)}
                value={cadastroAmbiental}
                marginBottom='10px'
            />

            <Select
                marginBottom='38px'
                labelWithAsterisk={isEstadoObrigatorio(estadoLocal)}
                label="Selecionar coordenadas geográficas"
                name="select_coordinates"
                className="select"
                id="select_coordinates"
                onChange={(e) => changeModoCoord(e)}
                options={[
                    { value: 1, label: 'Selecionar no mapa' },
                    { value: 2, label: 'Digitar coordenadas' },

                ]}
                value={modoCoord}
                estado={false}
                loading={false}
                disabled={false}
                erro={
                    erroLatitude === true ||
                    erroLongitude === true ||
                    erroAltitude === true ||
                    erroLatitudeGraus === true ||
                    erroLatitudeMinutos === true ||
                    erroLatitudeSegundos === true ||
                    erroLongitudeGraus === true ||
                    erroLongitudeMinutos === true ||
                    erroLongitudeSegundos === true
                        ? true
                        : false
                }
                messageErro={false}
            />

            {showMapa ? (
                cepLocal && logradouroLocal && numeroLocal && bairroLocal && cidadeLocal && estadoLocal ? (
                    <MapaArea
                        label="Selecione o local de aplicação"
                        endereco={[logradouroLocal, numeroLocal, bairroLocal, cidadeLocal, estadoLocal, cepLocal].filter(Boolean).join(', ')}
                        onChange={(lat, lgt) => changeCoordinates(lat, lgt)}
                        skipAutoLocateOnDesktop={true}
                    />
                ) : null
            ) : showInputs ? (
                <>
                    <label className='labelcoord'>{isEstadoObrigatorio(estadoLocal) ? "Latitude (Obrigatório)" : "Latitude (opcional)"}</label>
                    <div className="coord">
                        <div className="partCoord">
                            <Input
                                label='Graus'
                                name="latatitude"
                                className="input"
                                id="lgraus"
                                value={latitudeGraus}
                                maxLength={2}
                                onChange={e => validateLatitude(1, e)}
                                erro={erroLatitude || erroLatitudeGraus}
                                inputmode="numeric"

                            />
                            <span>°</span>
                        </div>

                        <div className="partCoord">
                            <Input
                                label='Minutos'
                                name="latatitude"
                                className="input"
                                id="lminutos"
                                value={latitudeMinutos}
                                maxLength={2}
                                onChange={e => validateLatitude(2, e)}
                                style={{ marginTop: '16px' }}
                                erro={erroLatitude || erroLatitudeMinutos}
                                inputmode="numeric"

                            />
                            <span>'</span>
                        </div>

                        <div className="partCoord">
                            <Input
                                label='Segundos'
                                name="latatitude"
                                className="input"
                                id="lsegundos"
                                value={latitudeSegundos}
                                maxLength={4}
                                onChange={e => validateLatitude(3, e)}
                                style={{ marginTop: '16px' }}
                                erro={erroLatitude || erroLatitudeSegundos}
                                inputmode="numeric"

                            />
                            <span>"S</span>
                        </div>
                    </div>

                    <label className='labelcoord'>{isEstadoObrigatorio(estadoLocal) ? "Longitude (Obrigatório)" : "Longitude (opcional)"}</label>
                    <div className="coord">
                        <div className="partCoord">
                            <Input
                                label='Graus'
                                name="longitude"
                                className="input"
                                id="longrau"
                                value={longitudeGraus}
                                maxLength={2}
                                onChange={e => validateLongitude(1, e)}
                                erro={erroLongitude || erroLongitudeGraus}
                                inputmode="numeric"

                            />
                            <span>°</span>
                        </div>

                        <div className="partCoord">
                            <Input
                                label='Minutos'
                                name="longitude"
                                className="input"
                                id="lonminutos"
                                value={longitudeMinutos}
                                maxLength={2}
                                onChange={e => validateLongitude(2, e)}
                                style={{ marginTop: '16px' }}
                                erro={erroLongitude || erroLongitudeMinutos}
                                inputmode="numeric"

                            />
                            <span>'</span>
                        </div>

                        <div className="partCoord">
                            <Input
                                label='Segundos'
                                name="longitude"
                                className="input"
                                id="lonsegundos"
                                value={longitudeSegundos}
                                maxLength={4}
                                onChange={e => validateLongitude(3, e)}
                                style={{ marginTop: '16px' }}
                                erro={erroLongitude || erroLongitudeSegundos}
                                inputmode="numeric"

                            />
                            <span>"W</span>
                        </div>
                    </div>
                </>
            ) : (
                <>
                </>
            )}


            {estadoLocal === 'SC' ? (
                <Input
                    label="Altitude (Obrigatório)"
                    value={altitude}
                    name="altitude"
                    className="input"
                    id="altitude"
                    onChange={e => validateAltitude(e)}
                    unidade="Metros"
                    erro={erroAltitude}
                    inputmode="numeric"
                />
            ) : (null)}

            <div
                className="button-finish"
                style={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                }}
            >
                <Button
                    width='100%'
                    height='50px'
                    value='CADASTRAR'
                    outline={false}
                    disabled={false}
                    onClick={() => handlePost()}
                    loading={loading}
                />

            </div>
        </Form>
    </>)
}
export default AddLocalAplicacao;
